const DETAIL_AUTHORIZATION_ERROR_MESSAGE =
  'you are not authorized to access this record'
const DETAIL_AUTHORIZATION_CODES = ['UNAUTHORIZED', 'FORBIDDEN']

export const isDetailAuthorizationError = queryError => {
  const graphQLErrors = queryError?.graphQLErrors || []
  const hasAuthorizationCode = graphQLErrors.some(graphQLError => {
    const errorCode = graphQLError?.extensions?.code
    return (
      typeof errorCode === 'string' &&
      DETAIL_AUTHORIZATION_CODES.includes(errorCode.toUpperCase())
    )
  })
  if (hasAuthorizationCode) return true

  const statusCode =
    queryError?.networkError?.statusCode ||
    queryError?.networkError?.status ||
    queryError?.networkError?.response?.status
  if (statusCode === 401 || statusCode === 403) return true

  const errorMessage = queryError?.message?.toLowerCase() || ''
  return errorMessage.includes(DETAIL_AUTHORIZATION_ERROR_MESSAGE)
}
